// @flow
import VehicleField from '.'
import { wrapWithField } from 'mz-ui-kit/form/Field'

export default wrapWithField(VehicleField)
